export default __webpack_public_path__ + "static/media/optionBox.4e8dd37a.svg";